// Shared "Continue Chat" handler used by every surface that resumes the
// Saras AI conversation panel. The helper is intentionally pure: callers
// inject their state setters, alert function, and API wrappers so the same
// behaviour can be exercised from React handlers and unit tests.

export function makeContinueChatHandler({
  getCuriosityResumeState,
  fetchChatSessionsDirect,
  openChatSession,
  setActiveModule,
  setLearningSubModule,
  setActiveSidebarTab,
  alert,
  t,
}) {
  return async function continueChat(explicitConversationId) {
    setActiveModule("learning");
    setLearningSubModule("chat");
    setActiveSidebarTab("history");

    const resume = getCuriosityResumeState();
    const hasExplicitId =
      typeof explicitConversationId === "string" ||
      typeof explicitConversationId === "number";
    let convoId = hasExplicitId
      ? explicitConversationId
      : resume?.ai_pointer?.conversation_id ?? null;

    if (convoId == null) {
      const sessions = await fetchChatSessionsDirect(50).catch(() => []);
      const first = Array.isArray(sessions) ? sessions[0] : null;
      convoId =
        first?.conversation_id ?? first?.conversationId ?? first?.id ?? null;
    }

    if (convoId == null) {
      alert(
        t("Continue Chat"),
        t("No AI chats yet. Ask a question to get started."),
      );
      return;
    }

    await openChatSession(convoId, 200);
  };
}
